import React, { useState, useEffect, useCallback } from 'react';
import { useWindowSize } from '@yme/hooks/index';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { TabletTabs, TabsContent, DropDown } from './components';
import { TabsComponentWrapperStyled } from './styled';
export function Tabs({ tabData, children, colorTheme, isRightToLeft, preselectedTab, isShowDropDown = false, onTabChange, }) {
    const [activeTab, setActiveTab] = useState(preselectedTab ?? tabData[0]);
    const { isMobileView } = useWindowSize();
    const onClickHandler = useCallback((id) => {
        if (activeTab?.entityId !== id) {
            const newTab = tabData.find((item) => item?.entityId === id) || tabData[0];
            setActiveTab(newTab);
            onTabChange?.(newTab);
        }
    }, [activeTab?.entityId, onTabChange, tabData]);
    useEffect(() => {
        if (activeTab?.amountLabel) {
            const activeTabData = tabData.find((data) => data.entityId === activeTab.entityId);
            if (activeTabData && activeTab.amountLabel !== activeTabData?.amountLabel) {
                setActiveTab(activeTabData);
            }
        }
    }, [activeTab?.amountLabel, activeTab?.entityId, tabData]);
    useEffect(() => {
        if (preselectedTab && preselectedTab.entityId !== activeTab?.entityId) {
            setActiveTab(preselectedTab);
            onTabChange?.(preselectedTab);
        }
    }, [activeTab?.entityId, onTabChange, preselectedTab]);
    const isExistTabsContent = tabData.some((item) => Boolean(item.tabContent));
    if (!tabData.length || !activeTab) {
        return null;
    }
    return (React.createElement(TabsComponentWrapperStyled, null,
        isMobileView || isShowDropDown ? (React.createElement(DropDown, { tabData: tabData, activeTab: activeTab, onSetActiveTab: onClickHandler })) : (React.createElement(TabletTabs, { tabData: tabData, activeTab: activeTab, colorTheme: colorTheme, onSetActiveTab: onClickHandler })),
        children && React.createElement(FlexWrapper, { isFullWidth: true }, children),
        !children && isExistTabsContent && (React.createElement(TabsContent, { tabData: tabData, activeTab: activeTab, isRightToLeft: isRightToLeft }))));
}
Tabs.displayName = 'Tabs';
